// extracted by mini-css-extract-plugin
export default {"agentTypingIndicator":"agent-typing_agentTypingIndicator__a-x4x"};